const articleStatus = {
  PUBLISHED: 'PUBLISHED',
  PRIVATE: 'PRIVATE',
  DRAFT: 'DRAFT',
  DELETED: 'DELETED'
}

const defaultArticleData = {
  id: null,
  document: '',
  description: '',
  categoryId: null,
  sectionId: null,
  title: '',
  slug: '',
  orgId: 1,
  status: articleStatus.DRAFT,
  backEndCopyOfArticleStatus: articleStatus.DRAFT,
  user: 1,
  timestamp: new Date().getTime(),
  version: 1,
  hostName: '',
  isSaving: false,
  isSaved: false,
  errors: []
}

const defaultCategoryData = {
  id: null,
  name: '',
  description: '',
  sections: [],
  documents: []
}

const defaultSectionData = {
  name: "",
  description: "",
  categoryId: null,
  documents: []
}

const selectorLabelNames = {
  publish: 'Publish',
  draft: 'Draft',
  private: 'Private'
}

const selectOptions = [
  {label: selectorLabelNames.draft, value: articleStatus.DRAFT},
  {label: selectorLabelNames.private, value: articleStatus.PRIVATE},
  {label: selectorLabelNames.publish, value: articleStatus.PUBLISHED}
]

const newCategorySuccessConfig = {type: 'success', message: 'Category created'}
const newCategoryFailureConfig = {type: 'error', message: 'Could not create category. Please try again'}

const editSuccessConfig = {type: 'success', message: 'Edit Successful'}
const editFailureConfig = {type: 'error', message: 'Edit Failed. Please try again'}

const newSectionSuccessConfig = {type: 'success', message: 'Section created'}
const newSectionFailureConfig = {type: 'error', message: 'Could not create section. Please try again'}

const deleteSuccessConfig = {type: 'success', message: 'Delete successful'}
const deleteFailureConfig = {type: 'error', message: 'Delete failed. Please try again'}

const newArticleFailureConfig = {type: 'error', message: 'Error creating article. Please try again'}

const fetchCategoriesFailureConfig = {type: 'error', message: 'Error getting your categories. Reload the page to try again'}

const reorderCategoriesSuccessConfig = { type: 'success', message: 'Successfully reordered!'}
const reorderCategoriesFailureConfig = { type: 'error', message: 'Oops, there was an error. Please try again.'}

export {
  defaultArticleData,
  articleStatus,
  selectOptions,
  defaultCategoryData,
  defaultSectionData,
  newCategorySuccessConfig,
  newCategoryFailureConfig,
  newSectionSuccessConfig,
  newSectionFailureConfig,
  editSuccessConfig,
  editFailureConfig,
  deleteSuccessConfig,
  deleteFailureConfig,
  newArticleFailureConfig,
  fetchCategoriesFailureConfig,
  reorderCategoriesSuccessConfig,
  reorderCategoriesFailureConfig
}